import { Component, Input, OnInit, ElementRef, SimpleChanges, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-grafico-barras',
  templateUrl: './grafico-barras.component.html',
  styleUrls: ['./grafico-barras.component.scss']
})
export class GraficoBarrasComponent implements OnInit {
  @Input() data = {};
  @ViewChild('canvas', {static: false}) canvas: any;

  public context: CanvasRenderingContext2D;

  chart: any
  labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July']
  dataG = [65, 59, 80, 81, 56, 55, 40]
  coloR = []

  constructor() {
  }

  ngOnInit(): void {
    this.context = this.canvas.nativeElement.getContext('2d');
    this.chart = new Chart(this.context, {
      type: 'bar',
      data: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [{
          data: [65, 59, 80, 81, 56, 55, 40],
          backgroundColor: 'rgba(108, 77, 60, 0.2)',
          borderColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1
        }]
      },
      options: {
        scales: {
            xAxes: [{
                stacked: true
            }],
            yAxes: [{
                stacked: true
            }]
        }
      }
    });
  }

  dynamicColors() {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
  };

  async ngOnChanges(changes: SimpleChanges) {
    setTimeout(async ()=>{
      let data = []
      changes.data.currentValue.data.forEach( item => {
        const l = item.tiempo !== '' ? item.tiempo : item.column1
        const index = data.findIndex( x => x.label == l)
        if(index == -1){
          data.push({
            label: l,
            data: [item.column2],
            backgroundColor: this.dynamicColors(),
          })
        }else{
          data[index].data.push(item.column2)
        }
      })
      this.chart.data.datasets = data;
      const labels = changes.data.currentValue.data.map( item => {
        return item.tiempo !== '' ? item.column1 : item.tiempo
      });
      this.chart.data.labels = labels.filter((value, index, array) => array.indexOf(value) === index);
      this.chart.update();
    },500)
  }
}
